if (!window.AroPuffPickerInfoInitialized) {
  window.AroPuffPickerInfoInitialized = true;

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-aropuff-info-open]');

    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.aropuffInfoOpen);

      if (dialog?.showModal) {
        dialog.showModal();
      }

      return;
    }

    const closeButton = event.target.closest('[data-aropuff-info-close]');

    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target.matches('[data-aropuff-info-dialog]')) {
      event.target.close();
    }
  });
}
